<template>
  <div class="md:grid md:grid-cols-12">
    <!-- <div class="col-span-1 mt-40 text-center md:mt-48 lg:mt-52"><span class="font-bold text-pink-500 cursor-pointer text-7xl"> &lt; </span></div> -->
    <div class="md:col-span-12">
        <carousel :items='1' :dots='true' :nav="true" :center="true">
            <div v-for="slide in slides" :key="slide.id">
            <img class="py-4 lg:h-4/6 cust-border" :src="slide.path">
            </div>
        </carousel>
    </div>
    <!-- <div class="col-span-1 mt-40 text-center md:mt-48 lg:mt-52"><span class="font-bold text-pink-500 cursor-pointer text-7xl">&gt;</span></div> -->
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
    components: { carousel },
    props: ['slides']
}
</script>
<style scoped>
	.cust-border {
		border-radius: 5rem;
	}
</style>